import React from 'react';

import Table, { TABLE_TYPES, TABLE_CELL_ALIGN } from 'cirrus/Table';

import { logPropTypes } from './utils';

const AuditTrailDetailsClient = props => {
  const { log } = props;

  const {
    customer = {},
    product,
    location = {},
    register = {},
    device = {},
    clientIpAddress,
    userAgent,
  } = log;

  const tableHead = {
    hide: true,
    cells: [
      {
        key: 'fist-prop',
        width: '50%',
      },
      {
        key: 'first-details',
        width: '50%',
        align: TABLE_CELL_ALIGN.RIGHT,
      },
      {
        key: 'second-prop',
        width: '40%',
      },
      {
        key: 'second-details',
        width: '60%',
        align: TABLE_CELL_ALIGN.RIGHT,
      },
      {
        key: 'third-prop',
        width: '40%',
      },
      {
        key: 'third-details',
        width: '60%',
        align: TABLE_CELL_ALIGN.RIGHT,
      },
    ],
  };

  const tableBody = [
    {
      key: 'first-row',
      cells: [
        { content: 'Product:', className: 'cr-text--bold' },
        { content: product || 'N/A' },
        { content: 'Account ID:', className: 'cr-text--bold' },
        { content: customer.id || 'N/A' },
        { content: 'Device Info:', className: 'cr-text--bold' },
        { content: device.info || 'N/A' },
      ],
    },
    {
      key: 'second-row',
      cells: [
        { content: 'Location:', className: 'cr-text--bold' },
        { title: location.name, content: location.name || 'N/A' },
        { content: 'Register:', className: 'cr-text--bold' },
        { content: register.name || 'N/A' },
        { content: 'Device:', className: 'cr-text--bold' },
        { content: device.name || 'N/A' },
      ],
    },
    {
      key: 'third-row',
      cells: [
        { content: 'Location ID:', className: 'cr-text--bold' },
        { content: location.id || 'N/A' },
        { content: 'Register ID:', className: 'cr-text--bold' },
        { content: register.id || 'N/A' },
        { content: 'Device ID:', className: 'cr-text--bold' },
        { content: device.id || 'N/A' },
      ],
    },
    {
      key: 'forth-row',
      cells: [
        { content: 'Client IP Address:', className: 'cr-text--bold' },
        { content: clientIpAddress || 'N/A' },
        { content: 'User-agent:', className: 'cr-text--bold' },
        { content: userAgent || 'N/A', colSpan: 3 },
      ],
    },
  ];

  return (
    <div className="cr-flex cr-width-full cr-flex-row">
      <Table
        type={TABLE_TYPES.COMPACT}
        className="cr-mh-3 cr-flex-1"
        head={tableHead}
        body={tableBody}
      />
    </div>
  );
};

AuditTrailDetailsClient.propTypes = {
  log: logPropTypes,
};

export default AuditTrailDetailsClient;
